import * as THREE from 'three';

import YinkaColor from './YinkaColors.js';
import { gsap } from "gsap";
import {degrees_to_radians} from './Utils.js';

function rrand(min, max) {
	return Math.random()*(max-min)+min;
};


export default class Boid{

  constructor(){
    this.range = 2;
    this.time = Math.random() * 10;
    this.colors = new YinkaColor();
		this.altitude = 8;
		this.homeRadius = 50;
		this.isSeeking = false;
		this.seekMode = "seeking";
		this.pointAt = new THREE.Vector3();
		this.steerVec = new THREE.Vector3();
		this.desVec = new THREE.Vector3();
		this.totalVec  = new THREE.Vector3();
		this.totalVecCoh  = new THREE.Vector3();
  }

  init(mesh,homeposition){
    let r = 6;

    this.position = new THREE.Vector3( rrand(-r,r), 5, rrand(-r,r));
    this.velocity = new THREE.Vector3(rrand(-1,1),rrand(-1,1),rrand(-1,1));
    this.acceleration = new THREE.Vector3(0,0,0);
    this.mass = 0.5;

    this.separationFactor = 0.06;
    this.alignmentFactor = 0.06;
    this.cohesionFactor = 0.02;
    this.centeringFactor = 0.01;

    this.maxSpeed = 2;
    this.maxAcceleration = 2;

    this.obj = {};
		mesh.position.copy(homeposition);
    this.obj.mesh = mesh;
    this.home = new THREE.Vector3(0,this.altitude,0);//homeposition.x,homeposition.y,homeposition.z);

		this.homeMesh = new THREE.Mesh( new THREE.BoxGeometry(.2,.2,.2),new THREE.MeshStandardMaterial({color:0xff0000}));

		let color = new THREE.Color( 0x6BB647);//this.colors.getRandom() );

    mesh.traverse((item) => {
      if(item.name == "Bird_RW"){
        this.Bird_RW = item;

      }else if(item.name == "Bird_LW"){
        this.Bird_LW = item;

      }


      if(item.material){
				item.material = new THREE.MeshToonMaterial({color:color});
			}
        //item.material.color = color;
    });


		const geometry = new THREE.BoxGeometry( .5,.25,.15 );
		const material = new THREE.MeshStandardMaterial( { color: new THREE.Color(0xff0000), transparent:true, opacity: 0 } );
		const cube = new THREE.Mesh( geometry, material );
		// mesh.add(cube);
		cube.position.z += .5;
		cube.rotation.y = Math.PI / 2;
		this.cube = cube;
		    // this.mixer = new THREE.AnimationMixer( glb );
    // this.clips = glb.animations;
    //
    //
    // const clip = THREE.AnimationClip.findByName( this.clips, 'Take 001' );
    // const action = this.mixer.clipAction( clip );
    // action.play();

  }

	seekTarget(target,dt,lookAhead){

		if(!this.isSeeking){
			gsap.to(this.obj.mesh.scale,{x:.5,y:.5,z:.5,duration:.5});

			this.seekMode = "seeking";
		}

		this.isSeeking = true;

		let distToTarget = this.obj.mesh.position.distanceTo(target);

		if(distToTarget < .01 && this.seekMode != "sitting"){

			this.obj.mesh.position.copy(target);
			// this.Bird_RW.rotation.z = .501;
			// this.Bird_LW.rotation.z = Math.PI - .501;
			gsap.to(this.Bird_RW.rotation,{x:degrees_to_radians(10),y:degrees_to_radians(20),duration:.2});
			gsap.to(this.Bird_LW.rotation,{x:degrees_to_radians(10),y:degrees_to_radians(-20),duration:.2});

			gsap.to(this.Bird_RW.rotation,{z:.5,duration:.2});
			gsap.to(this.Bird_LW.rotation,{z:Math.PI -.5,duration:.2});

			this.offRot = {val:0};//this.obj.mesh.rotation.y;

			this.seekTL = gsap.timeline({repeat: -1, repeatDelay: 2});
			this.seekTL.to(this.Bird_RW.rotation,{z:0,duration:.2});
			this.seekTL.to(this.Bird_RW.rotation,{z:.5,duration:.2});
			this.seekTL.to(this.Bird_LW.rotation,{z:Math.PI -0,duration:.2});
			this.seekTL.to(this.Bird_LW.rotation,{z:Math.PI -.5,duration:.2});
			this.seekTL.to(this.offRot,{val:.1,duration:.2, delay:.5});
			this.seekTL.to(this.offRot,{val:0,duration:.2});
			// this.seekTL.to(this.obj.mesh.rotation,{y:oRot+.1,duration:.2, delay:.5});
			// this.seekTL.to(this.obj.mesh.rotation,{y:oRot,duration:.2});

			// this.seekMode = "sitting";
		}

		// if(this.seekMode == "sitting"){
		// 	this.obj.mesh.position.copy(target);
		// 	this.obj.mesh.lookAt(lookAhead);
		// 	this.obj.mesh.rotateY(Math.PI + this.offRot.val);
		//
		// 	return;
		// }

		this.obj.mesh.position.x = .9 * this.obj.mesh.position.x + .1 * target.x;
		this.obj.mesh.position.y = .9 * this.obj.mesh.position.y + .1 * target.y;
		this.obj.mesh.position.z = .9 * this.obj.mesh.position.z + .1 * target.z;

		// this.obj.mesh.lookAt(lookAhead);
		this.pointAt.set(this.position.x+this.velocity.x, this.position.y+this.velocity.y,this.position.z+this.velocity.z);
  	this.obj.mesh.lookAt(target);
    this.obj.mesh.rotateY(Math.PI);
		this.position.copy(this.obj.mesh.position);

		this.time += dt;
		this.Bird_RW.rotation.z = Math.sin(this.time*2*Math.PI*2.0)*0.5;
		this.Bird_LW.rotation.z = Math.PI - Math.sin(this.time*2*Math.PI*2.0)*0.5;

	}

  step(dt, flock, seekTarget = null) {

		// if(homeTarget != null){
		// 	this.home.x = homeTarget.x + this.homeRadius * Math.cos(this.time*.1*Math.PI*2.0);
		// 	this.home.z = homeTarget.z + this.homeRadius * Math.sin(this.time*.1*Math.PI*2.0);
		// }else{
		// 	this.home.x = this.homeRadius * Math.cos(this.time*.1*Math.PI*2.0);
	  //   this.home.z = this.homeRadius * Math.sin(this.time*.1*Math.PI*2.0);
		// }

		this.home.x = this.homeRadius * Math.cos(this.time*.025*Math.PI*2.0);
		this.home.z = this.homeRadius * Math.sin(this.time*.025*Math.PI*2.0);

    this.accumulate(flock);
    this.update(dt);
    // this.mixer.update(dt);
    this.time += dt;
    this.Bird_RW.rotation.z = Math.sin(this.time*2*Math.PI*2.0)*0.5;
    this.Bird_LW.rotation.z = Math.PI - Math.sin(this.time*2*Math.PI*2.0)*0.5;

    this.obj.mesh.position.set(this.position.x, this.position.y, this.position.z);
  }

  accumulate(flock) {
    var separation, alignment, cohesion, centering;

    separation = this.separate(flock).multiplyScalar(this.separationFactor); //0.02
    alignment = this.align(flock).multiplyScalar(this.alignmentFactor); // 0.05
    cohesion = this.cohesion(flock).multiplyScalar(this.cohesionFactor); //0.01
    //centering = this.steer(this.home).multiplyScalar(0.001);
    centering = this.steer(this.home).multiplyScalar(this.centeringFactor);
    centering.multiplyScalar(this.position.distanceTo(this.home)*this.centeringFactor*3.0); // stronger centering if farther away
    this.acceleration.add(separation);
    this.acceleration.add(alignment);
    this.acceleration.add(cohesion);
    this.acceleration.add(centering);
    this.acceleration.divideScalar(this.mass);
  }

  update(dt) {

    if (dt > 0.1)
      dt = 0.1;
  	this.acceleration.multiplyScalar(this.maxAcceleration*dt); //HERE

		if(this.position.y < 2){
			if(this.acceleration.y < 0){
				this.acceleration.y = -this.velocity.y;
			}else if(this.acceleration.y == 0){
				this.acceleration.y = .025;
			}else{
				this.acceleration.y *= 1.1;
			}
		}
  	this.velocity.add(this.acceleration);
  	this.velocity.clampLength(0,this.maxSpeed*dt);

  	this.position.add(this.velocity);
  	this.acceleration.set(0,0,0); // reset each iteration

    this.pointAt.set(this.position.x+this.velocity.x, this.position.y+this.velocity.y,this.position.z+this.velocity.z);
  	this.obj.mesh.lookAt(this.pointAt);
    this.obj.mesh.rotateY(Math.PI);
  }

  separate(flock) {
    var minRange = 5; //60
    var currBoid;
    //var total = new THREE.Vector3(0,0,0);
		this.totalVec.set(0,0,0);
    var count = 0;
    // Find total weight of separation
    for (var i = 0; i < flock.length; i++) {
    currBoid = flock[i];
    var dist = this.position.distanceTo(currBoid.position);
    // Apply weight if too close
      if (dist < minRange && dist > 0) {
      	var force = this.position.clone();
      	force.sub(currBoid.position);
      	force.normalize();
      	force.divideScalar(dist);
      	this.totalVec.add(force);
      	count++;
      }
    }
    // Average out total weight
    if (count > 0) {
      this.totalVec.divideScalar(count);
      this.totalVec.normalize();
    }
    return this.totalVec;
  }

  align(flock) {
    var neighborRange = 10;
    var currBoid;
    // var total = new THREE.Vector3(0,0,0);
    this.totalVec.set(0,0,0);
		var count = 0;

    // Find total weight for alignment
    for (var i = 0; i < flock.length; i++) {
    	currBoid = flock[i];
    	var dist = this.position.distanceTo(currBoid.position);
    	// Apply force if near enough
    	if (dist < neighborRange && dist > 0) {
    		this.totalVec.add(currBoid.velocity);
    		count++;
    	}
    }
	   // Average out total weight
    if (count > 0) {
      this.totalVec.divideScalar(count);
      this.totalVec.limit(1);
    }

    return this.totalVec;
  }

  cohesion(flock) {
    var neighborRange = 10;
    var currBoid;
    //var total = new THREE.Vector3(0,0,0);
		this.totalVecCoh.set(0,0,0);

		var count = 0;
    // Find total weight for cohesion
    for (var i = 0; i < flock.length; i++) {
    	currBoid = flock[i];
    	var dist = this.position.distanceTo(currBoid.position);
    	// Apply weight if near enough
    	if (dist < neighborRange && dist > 0) {
        this.totalVecCoh.add(currBoid.position);
        count++;
    	}
    }
    // Average out total weight
    if (count > 0) {
    	this.totalVecCoh.divideScalar(count);
    	// Find direction to steer with
    	return this.steer(this.totalVecCoh);
    }
    else {
    	return this.totalVecCoh;
    }
  }

  steer(target) {
  	this.steerVec.set(0,0,0);
  	this.desVec.set(0,0,0).subVectors(target, this.position);
  	var dist = this.desVec.length();
  	if (dist > 0) {
  		this.desVec.normalize();
  		this.steerVec.subVectors(this.desVec, this.velocity);
  	}
  	return this.steerVec;
  }

}

// Limit max forces
THREE.Vector3.prototype.limit = function(max) {
	if (this.length() > max) {
		this.normalize();
		this.multiplyScalar(max);
	}
}
